module.exports = __webpack_public_path__ + "media/images/products/cards/default_product-8a48bba18b4b02adf02945ce19de8e35.png";